import{environment as Giemmea } from './BaseEnvironments/Giemmea'

function Environment() {
  var Env = Giemmea;
  Env.apiUrl = 'https://www.giemmea.eu/api';
  return Env
}

export var environment = Environment();
